(() => {
 'use strict';
 function setup(scope){
  scope.querySelectorAll('[data-campaign-film]').forEach(container=>{
   if(container.dataset.filmReady)return;container.dataset.filmReady='true';
   const video=container.querySelector('video'),button=container.querySelector('[data-film-toggle]');if(!video||!button)return;
   video.muted=true;
   button.setAttribute('aria-controls',video.id);
   const sync=()=>{const label=video.paused?button.dataset.playLabel:button.dataset.pauseLabel;button.textContent=label;button.setAttribute('aria-label',label);};
   const play=()=>{try{const result=video.play();result?.catch(sync);}catch{sync();}};
   video.controls=false;button.hidden=false;sync();
   video.addEventListener('play',sync);video.addEventListener('pause',sync);
   button.addEventListener('click',()=>{if(video.paused)play();else video.pause();});
   if(window.matchMedia&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){video.autoplay=true;play();}
  });
 }
 setup(document);
 document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
